import React from 'react';
import {ArrowRightIcon} from '@heroicons/react/24/outline';

import {Button, Card, CardContent, CardFooter, CardHeader} from '@design-system';

/**
 * One resource in a Professional list. `data-testid` stays the item's name
 * because the Professional journey selects cards by it; the visually hidden
 * suffix gives each "Learn More" action a name that stands on its own.
 */
const ProItemCard = ({item, onClick, description, titleAs: Title = 'p'}) => {
  return (
    <Card data-testid="pro-item-card" className="flex h-full min-w-0 flex-col">
      <CardHeader className="flex-row items-center gap-3">
        {item.icon ? (
          <img src={item.icon} width={42} height={42} alt="" className="size-[42px] shrink-0" />
        ) : null}
        <Title className="m-0 min-w-0 text-base font-semibold break-words">{item.name}</Title>
      </CardHeader>
      <CardContent className="flex-1">
        {description ? <p className="m-0 text-sm">{description}</p> : null}
      </CardContent>
      <CardFooter>
        <Button variant="outline" className="min-h-11" data-testid={item.name} onClick={onClick}>
          Learn More<span className="sr-only"> about {item.name}</span>
          <ArrowRightIcon className="size-5" aria-hidden="true" />
        </Button>
      </CardFooter>
    </Card>
  );
};

export default ProItemCard;
